import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  connect() {
    // Skip scroll handling for mobile-inline variant (it's static, not sticky)
    if (this.element.classList.contains("c-event_info_card-card--mobile-inline")) return;
    // Skip on desktop
    if (!window.matchMedia("(max-width: 767px)").matches) return;

    this.bar         = this.element;
    this.lastScrollY = window.scrollY;
    this.onScroll    = this.handleScroll.bind(this);

    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  handleScroll() {
    const scrollY   = window.scrollY
    const innerH    = window.innerHeight
    const fullH     = document.documentElement.scrollHeight
    const atBottom  = scrollY + innerH >= fullH - 5
    const scrollUp  = scrollY < this.lastScrollY

    if (atBottom) {
      this.bar.classList.add("c-event_info_card-card__is-hidden");
    } else if (scrollUp) {
      this.bar.classList.remove("c-event_info_card-card__is-hidden");
    }

    this.lastScrollY = scrollY;
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }
}